/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/
import * as THREE from 'three'
import React, { useEffect, useRef, Suspense } from 'react'
import { useGLTF, useAnimations, Loader } from '@react-three/drei'
import { useFrame } from '@react-three/fiber'
import { useState } from 'react'



export function Model(props) {
  const group = useRef()
  const { nodes, materials, animations } = useGLTF('/models/Alpha_Eco_v6.glb')
  const { ref, actions, names }  = useAnimations(animations, group)
  
  materials.AO_House_1.color = new THREE.Color().setHex(0x13DAEC)
  materials['AO_Tower.002'].color = new THREE.Color().setHex(0xFF8C1A)
  materials.AO_Res_Block_1.color = new THREE.Color().setHex(0xFF70DB)

  useEffect(()=>
  {
    if(actions.Car_Moving != null){
      actions.Car_Moving.play()
    }
  },[])


  return (
    
    <group ref={group} {...props} dispose={null}>
      <group name="Scene">
        <group name="Scene_Collection">
          <mesh name="BigGround" onClick={(e) => actions.Car_Moving.play()} geometry={nodes.BigGround.geometry} material={materials.Ground} />
          <mesh
            name="GrassField"
            geometry={nodes.GrassField.geometry}
            material={materials.GrassField}
          />
          <group name="CT_03" position={[18.587, 3.967, -12.674]} />
          <group name="CT_02" position={[-20.436, 9.056, -22.851]} />
          <group name="CT_01" position={[-27.423, 0.271, 32.393]} />
          <group name="CP_03" position={[29.995, 7.673, -19.485]} />
          <group name="CP_02" position={[-2.164, 14.015, -42.093]} />
          <group name="CP_01" position={[-23.802, 6.989, 21.525]} />
          <group name="Res_Block_1">
            <mesh
              name="Res_Block1"
              geometry={nodes.Res_Block1.geometry}
              material={materials.AO_Res_Block_1}
            />
            <mesh
              name="Brick_fence_with_a_booth001"
              geometry={nodes.Brick_fence_with_a_booth001.geometry}
              material={materials.AO_Fence}
            />
          </group>
          <group name="Res_Block_3">
            <mesh name="Hotel" geometry={nodes.Hotel.geometry} material={materials.AO_Hotel} />
          </group>
          <group name="Res_House_1">
            <mesh
              name="Res_House_1_1"
              geometry={nodes.Res_House_1_1.geometry}
              material={materials.AO_House_1}
            />
          </group>
          <group name="Bus_stop">
            <mesh
              name="Bus_Stop"
              geometry={nodes.Bus_Stop.geometry}
              material={materials.AO_Bus_Stop}
            />
          </group>
          <group name="Roads">
            <mesh name="Road" geometry={nodes.Road.geometry} material={materials.M_Road} />
          </group>
          <group name="Res_Houses">
            <mesh
              name="Res_House_2"
              geometry={nodes.Res_House_2.geometry}
              material={materials.AO_House_2}
            />
            <mesh
              name="Res_House_3"
              geometry={nodes.Res_House_3.geometry}
              material={materials.AO_House_3}
            />
            <mesh
              name="Res_House_4"
              geometry={nodes.Res_House_4.geometry}
              material={materials.AP_House_4}
            />
            <mesh
              name="Res_House_5"
              geometry={nodes.Res_House_5.geometry}
              material={materials.AO_House_5}
            />
            <mesh
              name="Res_House_6"
              geometry={nodes.Res_House_6.geometry}
              material={materials.AO_House_6}
            />
            <mesh
              name="Res_House_7"
              geometry={nodes.Res_House_7.geometry}
              material={materials.AO_House_7}
            />
            <mesh
              name="Res_House_8"
              geometry={nodes.Res_House_8.geometry}
              material={materials.AO_Res_House_8}
            />
            <mesh
              name="Res_House_9"
              geometry={nodes.Res_House_9.geometry}
              material={materials.AO_House_9}
            />
          </group>
          <group name="Football_Pitch">
            <mesh
              name="FootballPitch"
              geometry={nodes.FootballPitch.geometry}
              material={materials.AO_FootballPitch}
            />
          </group>
          <group name="Quicki_Mart">
            <mesh
              name="QuickieMart"
              geometry={nodes.QuickieMart.geometry}
              material={materials.AO_Quickiemart}
            />
          </group>
          <group name="Fountain">
            <mesh
              name="Fountains"
              geometry={nodes.Fountains.geometry}
              material={materials.AO_Fountains}
            />
          </group>
          <group name="Trees">
            <mesh name="TREES" geometry={nodes.TREES.geometry} material={materials.AO_Trees} />
          </group>
          <group name="Tower_Blocks">
            <mesh
              name="Tower001"
              geometry={nodes.Tower001.geometry}
              material={materials['AO_Tower.001']}
            />
            <mesh
              name="Tower002"
              geometry={nodes.Tower002.geometry}
              material={materials['AO_Tower.002']}
            />
            <mesh
              name="Tower004"
              geometry={nodes.Tower004.geometry}
              material={materials['AO_Tower.004']}
            />
            <mesh
              name="Tower005"
              geometry={nodes.Tower005.geometry}
              material={materials['AO_Tower.005']}
            />
          </group>
          <group name="RoadLightsSigns">
            <mesh
              name="RoadLightsSigns_1"
              geometry={nodes.RoadLightsSigns_1.geometry}
              material={materials.AO_RoadLightsSigns}
            />
          </group>
          <group name="Bins">
            <mesh name="TRASH" geometry={nodes.TRASH.geometry} material={materials.AO_Trash} />
          </group>
          <group name="Procedural_building">
            <group name="Procedural_building_hidden" />
            <group name="1st_floor" />
            <group name="Walls" />
            <group name="flowerpot" />
          </group>
          <group name="Grass" />
          <group name="Cars">
            <mesh
              name="Car_Moving"
              geometry={nodes.Car_Moving.geometry}
              material={materials.CarMoving}
              position={[-0.768, 0.287, 49.427]}
              rotation={[0, -1.571, 0]}
              scale={2.006}
            />
            <mesh name="Cars_1" geometry={nodes.Cars_1.geometry} material={materials.Car} />
          </group>
        </group>
      </group>
      
    </group>
   
  )
}

export function PlayAnimation() {
  const group = useRef()
  const { nodes, materials, animations } = useGLTF('/models/Alpha_Eco_v6.glb')
  const { ref, actions, names }  = useAnimations(animations, group)

  
}



